module.exports = __webpack_public_path__ + "static/media/Eterno_Thumbnails.02.e06efbe0.png";